import { forwardRef } from "react";
import type { EquiplyIconProps, EquiplyIcon } from "../types";

/** Brouillon — cercle pointillé duotone */
export const DraftIcon: EquiplyIcon = forwardRef<SVGSVGElement, EquiplyIconProps>(
  ({ size = 24, ...props }, ref) => (
    <svg ref={ref} width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      <circle cx="12" cy="12" r="9.5" fill="var(--equiply-icon-bg)" fillOpacity="0.3" />
      <circle
        cx="12" cy="12" r="8.25"
        stroke="var(--equiply-icon-fg)" strokeWidth="1.5"
        strokeDasharray="3 2.5"
      />
      {/* Crayon central */}
      <path
        d="M10 14l4-4M13 9l1.5 1.5"
        stroke="var(--equiply-icon-fg)" strokeWidth="1.5" strokeLinecap="round"
      />
    </svg>
  ),
);
DraftIcon.displayName = "DraftIcon";
